import { configureStore, combineReducers } from '@reduxjs/toolkit';
import localeSlice from './localeSlice';
import routerSlice from './routerSlice';

const reducer = combineReducers({
  locale: localeSlice,
  pathName: routerSlice
});

const store = configureStore({
  reducer,
});

export type RootState = ReturnType<typeof store.getState>
export default store;